// extracted by mini-css-extract-plugin
export default {"icon":"b32esU","userIcon":"c32esU","labels":"d32esU","label":"e32esU","branded":"f32esU","text":"g32esU"};